import React from "react";
import { useNavigate } from "react-router-dom";
import ItemGrid from "../ItemGrid/ItemGrid";
import './Dashboard.css'; // Path must match your project's structure


const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const handleOptionClick = () => {
    window.open("/options", "_blank"); // Open in a new tab
   };

  return (
    <div className="dashboard-container">
       <div className=""> 
        <button onClick={handleOptionClick}>Options</button>
      </div>

      {/* Logout Button */}
      <div className="logout-button"> 
        <button onClick={handleLogout}>Logout</button>
      </div>

      {/* Main Content */}
      <div className="dashboard-content">
      </div>
      <div>
        <ItemGrid /> {/* Include the ItemGrid component */}
        </div>
    </div>
  );
};

export default Dashboard;
